import React, { useEffect, useState } from 'react';
import { get } from '../../services/back.service';
import InProgressList from '../../components/dashboard/InProgressList';

/**
 * Pantalla de avance de peritajes (WP4).
 *
 * Vista pensada para mostrarse en una pantalla: se abre con un usuario
 * autenticado y se deja visible. Muestra el % de completado de cada peritaje
 * en curso, con filtro por sede y actualización en tiempo real.
 */
export default function ProgressDisplay() {
  const [offices, setOffices] = useState([]);
  const [office, setOffice] = useState('');

  useEffect(() => {
    const loadOffices = async () => {
      const respo = await get('/peritaje/infoclientinspection/', {});
      if (respo.success && respo.data && respo.data.office) {
        setOffices(respo.data.office);
      }
    };
    loadOffices();
  }, []);

  return (
    <div
      className="container-fluid p-4"
      style={{ minHeight: '100vh', background: '#f1f5f9' }}
    >
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
        <h1 className="h3 mb-0">Avance de Peritajes</h1>
        <select
          className="form-select w-auto"
          aria-label="Filtrar por sede"
          value={office}
          onChange={(e) => setOffice(e.target.value)}
        >
          <option value="">Todas las sedes</option>
          {offices.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>
      </div>

      <InProgressList
        office={office || null}
        title="Peritajes en curso"
        displayMode
      />
    </div>
  );
}
